'use client';

const PERMIT_STATUS_CONFIG: Record<string, { label: string; bg: string; text: string; dot: string }> = {
  'not_started':          { label: 'Not Started',   bg: 'bg-gray-100',   text: 'text-gray-600',   dot: 'bg-gray-400' },
  'needs_filing':         { label: 'Needs Filing',  bg: 'bg-red-100',    text: 'text-red-700',    dot: 'bg-red-500' },
  'filed':                { label: 'Filed',         bg: 'bg-blue-100',   text: 'text-blue-700',   dot: 'bg-blue-500' },
  'pending_review':       { label: 'Under Review',  bg: 'bg-amber-100',  text: 'text-amber-700',  dot: 'bg-amber-500' },
  'approved':             { label: 'Approved',      bg: 'bg-green-100',  text: 'text-green-700',  dot: 'bg-green-500' },
  'scheduled_inspection': { label: 'Inspection',    bg: 'bg-purple-100', text: 'text-purple-700', dot: 'bg-purple-500' },
  'passed':               { label: 'Passed',        bg: 'bg-green-100',  text: 'text-green-700',  dot: 'bg-green-500' },
  'failed':               { label: 'Failed',        bg: 'bg-red-100',    text: 'text-red-700',    dot: 'bg-red-500' },
  'closed':               { label: 'Closed',        bg: 'bg-gray-100',   text: 'text-gray-600',   dot: 'bg-gray-400' },
  'not_required':         { label: 'Not Required',  bg: 'bg-gray-50',    text: 'text-gray-500',   dot: 'bg-gray-300' },
};

interface PermitChipProps {
  status: string;
}

const PermitChip = ({ status }: PermitChipProps) => {
  const cfg = PERMIT_STATUS_CONFIG[status] ?? PERMIT_STATUS_CONFIG['not_started'];

  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-[11px] font-semibold ${cfg.bg} ${cfg.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      <span className="uppercase tracking-wide text-[10px]">Permit:</span>
      <span>{cfg.label}</span>
    </span>
  );
};

export default PermitChip;
